import {CanActivateFn} from '@angular/router';
import {inject} from "@angular/core";
import {CommonService} from "../service/common.service";
import {NavController} from "@ionic/angular";
import {UserService} from "../service/user.service";
import {AppVersionService} from "../service/app-version.service";
import {NavigationService} from "../service/navigation.service";

export const activeVersionGuard: CanActivateFn = async () => {

  const navigationService = inject(NavigationService);
  const appVersionService = inject(AppVersionService);

  const isActive = await appVersionService.checkIsActiveVersion();
  const hasVersion = appVersionService.currentActiveVersion;

  if(!hasVersion){
    navigationService.goRoot(['/down-app']);
    return false;
  }

  if (isActive) {
    return true;
  } else {
    navigationService.goRoot(['/update']);
    return false;
  }
};
